import { ReactElement, useEffect, useState } from 'react'
import {
    StyledAccordion,
    AccordionContent,
    AccordionButton,
    ArrowWrapper,
} from './styles'
import { SVG, SVGs } from '../..'
import { AccordionProps } from './props'
import useElementSize from '../../Hooks/useElementSize'

const Accordion = ({
    buttonBackground,
    content,
    disabled = false,
    isOpen = false,
    onClick = () => undefined,
    showButtonIcon = true,
    variant = 'Default',
    startIcon,
    title,
    ['data-cy']: dataCy,
}: AccordionProps): ReactElement => {
    const [buttonRef, buttonSize] = useElementSize()
    const [contentRef, contentSize] = useElementSize()

    const [isLocalOpen, setIsLocalOpen] = useState(isOpen)
    const [canOverflow, setCanOverflow] = useState(false)

    useEffect(() => {
        setIsLocalOpen(isOpen)

        if (!isOpen) setCanOverflow(false)
        else
            setTimeout(() => {
                setCanOverflow(true)
            }, 300)
    }, [isOpen])

    return (
        <StyledAccordion
            variant={variant}
            disabled={disabled}
            isOpen={isLocalOpen}
            canOverflow={canOverflow}
            css={{
                maxH:
                    buttonSize.height + (isLocalOpen ? contentSize.height : 0),
            }}
            data-cy={dataCy ?? 'accordion'}
            onTransitionEnd={() => {
                if (isLocalOpen) setCanOverflow(true)
            }}
        >
            <AccordionButton
                onClick={() => {
                    onClick()
                    setCanOverflow(false)
                    setIsLocalOpen(!isLocalOpen)
                }}
                ref={buttonRef}
                css={{ bgc: buttonBackground ?? '' }}
            >
                {startIcon}
                {typeof title === 'function' ? title(isLocalOpen) : title}
                {showButtonIcon && (
                    <ArrowWrapper>
                        <SVG src={SVGs.ChevronDown} />
                    </ArrowWrapper>
                )}
            </AccordionButton>
            {content && (
                <AccordionContent ref={contentRef}>{content}</AccordionContent>
            )}
        </StyledAccordion>
    )
}

export default Accordion

export { StyledAccordion }
